import Store from 'lib/Store';
import VersionedItemSubstore, {
  ItemEditorState,
  VersionBase,
  ItemVersionState,
} from 'notebook/store/VersionedItemSubstore';
import {EntryNote, NotePart} from 'notebook/util/NoteUtilConstants';

export default abstract class BaseEntryStore<
  TEntryClient = unknown,
  TEntryServer = unknown,
  TEntryVersionServer extends VersionBase = VersionBase,
  TItemKey extends string = string,
  TIdKey extends string = string,
> extends Store {
  itemSubstore!: VersionedItemSubstore<
    TEntryClient,
    NotePart,
    TEntryServer,
    TEntryVersionServer,
    TItemKey,
    TIdKey
  >;

  override resetState(): void {
    if (this.itemSubstore == null) {
      this.itemSubstore = this.createItemSubstore();
    }
    this.itemSubstore.resetState();
  }

  abstract createItemSubstore(): VersionedItemSubstore<
    TEntryClient,
    NotePart,
    TEntryServer,
    TEntryVersionServer,
    TItemKey,
    TIdKey
  >;
  abstract getNote(id: string): EntryNote;

  inStore(id: string): boolean {
    return this.itemSubstore.inStore(id);
  }

  getEditorState(id: string): ItemEditorState<TEntryClient, NotePart, TItemKey, TIdKey> | undefined {
    return this.itemSubstore.getEditorState(id);
  }

  getVersionState(id: string): ItemVersionState<TEntryVersionServer> | undefined {
    return this.itemSubstore.getVersionState(id);
  }

  getIdFromCid(id: string, cid: string): string | number | undefined {
    return this.itemSubstore.getIdFromCid(id, cid);
  }

  hasUnsavedChanges(id: string): boolean {
    return this.itemSubstore.hasUnsavedChanges(id);
  }

  queueSave(id: string): void | JQueryPromise<boolean> {
    return this.itemSubstore.queueSave(id);
  }
}
